import React, { useState } from 'react'
import {
  GetApp as GetAppIcon,
  Visibility,
  HighlightOff as HighlightOffIcon,
} from '@mui/icons-material'
import {
  Typography,
  Dialog,
  DialogTitle,
  IconButton,
  CircularProgress,
} from '@mui/material'
import { useAuthContext } from '../../hooks/useAuthContext'
import { fileServices } from '../../services/fileServices'
import FileViewer from './PreviewComponent/components/FileViewer'

const DocumentDialogBox = ({
  isDocOpen,
  title,
  setIsDocOpen,
  setTimelineOpen,
  docData,
  timelines,
  DocStyle,
}) => {
  const { user } = useAuthContext()
  const [isLoading, setIsLoading] = useState(false)
  const [loading, setLoading] = useState(new Set())
  const [previewFileKey, setPreviewFileKey] = useState(null)

  const uniqueActivityIds = [...new Set(timelines.map((item) => item.activity_template_id))]
  const filteredTimeLine = docData
    ?.filter((item) => uniqueActivityIds.includes(item.activity_template_id))
    .sort((a, b) => a.sequence - b.sequence)

  const documentProcessId = [...new Set(docData.map((item) => item.process_id))]
  const filteredDocTimeLine = timelines?.filter((item) => documentProcessId.includes(item.id))

  const docHeaderStyle = {
    display: 'flex',
    justifyContent: 'space-between',
  }
  const docTitleStyle = {
    padding: '0 0 15px 26px',
    color: '#0000EE',
  }
  const docIconStyle = {
    padding: '0 26px 15px 0px',
    color: '#0000EE',
  }

  const downloadFile = async (fileName, index) => {
   
    if (loading.has(index)) {
      return
    }
 
   
    setLoading((prev) => new Set([...prev, index]))
    setIsLoading(true)
 
    try {
      await fileServices.downloadFile(user, fileName, 'documents_for_template')
    } catch (error) {
      console.error('Error downloading file:', error)
    } finally {
     
      setLoading((prev) => {
        const updated = new Set(prev)
        updated.delete(index)
        return updated
      })
      setIsLoading(false)
    }
  }



  return (
    <>
      <Dialog
        open={isDocOpen && !previewFileKey}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        style={{ width: '-webkit-fill-available%' }}
        onClose={() => {
          setIsDocOpen(false)
          setTimelineOpen(true)
        }}
        fullWidth={true}
      >
        <div style={docHeaderStyle}>
          <DialogTitle id="alert-dialog-title">
            <div>{title}</div>
            {filteredDocTimeLine?.map((data, i) => (
              <Typography variant="subtitle2" component="span" key={i}>
                {`${data.activity_template_name} (version: ${data.version})`}
              </Typography>
            ))}
          </DialogTitle>
          <div style={{ display: 'inline-block', margin: '20px 28px 0px 0px' }}>
            <IconButton
              align="right"
              onClick={() => {
                setIsDocOpen(false)
                setTimelineOpen(true)
              }}
              size="large"
            >
              <HighlightOffIcon />
            </IconButton>
          </div>
        </div>

        {filteredTimeLine &&
          filteredTimeLine.map((file, i) => (
            <div
              key={i}
              style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}
            >
              <span style={docTitleStyle}>{file.document_template_name}</span>

              <span style={docIconStyle}>
                <IconButton
                  size="small"
                  onClick={() => {
                    setPreviewFileKey(`documents_for_template/${file.document_key}`)
                  }}
                >
                  <Visibility size="small" />
                </IconButton>

                <IconButton
                  size="small"
                  download
                  onClick={() => downloadFile(file.document_key, i)}
                >
                  {loading.has(i) ? (
                    <CircularProgress color="info" size={'25px'} />
                  ) : (
                    <GetAppIcon color="info" size="small" />
                  )}
                </IconButton>
              </span>
            </div>
          ))}
      </Dialog>
      <FileViewer
        open={!!previewFileKey}
        onClose={() => {
          setPreviewFileKey(null)
        }}
        fileKey={previewFileKey}
        user={user}
        onDownload={() => {
          if (previewFileKey) {
            const keyOnly = previewFileKey.split('/').pop()
            const fileIndex = docData.findIndex((f) => f.document_key === keyOnly)
            downloadFile(keyOnly, fileIndex !== -1 ? fileIndex : 0)
          }
        }}
      />
    </>
  )
}

export default DocumentDialogBox
